export default __webpack_public_path__ + "static/media/iryqua.669895e2.png";